import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  NavigationHelper,
  TableBaselines,
  API,
  GlobalActions,
  viAdd,
  withRouter,
} from 'vibeguide';
import SubNavigation from '../../../Header/SubNavigation';
import BaselineSidebar from '../Sidebar/BaselineSidebar';

function VisualBaselinesList({
  className = '',
  style = {},
  location,
  history,
  setPanel,
}) {
  const prevSearchRef = useRef(location.search);

  const onCloseSidebar = () => {
    const url = NavigationHelper.updateParams({
      baselineId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  const sidebar = (type, baselineId = null) => {
    setPanel({
      show: true,
      backdrop: type === 'new',
      width: 600,
      children: (
        <BaselineSidebar
          baselineId={baselineId}
          isNew={type === 'new'}
          mediaFormat="visual"
        />
      ),
      onClose: onCloseSidebar,
    });
  };

  useEffect(() => {
    const qs = NavigationHelper.getParams() || {};
    const isNew = qs.type === 'new';
    const isView = qs.baselineId && qs.type !== 'new';

    if (isNew || isView) {
      setTimeout(() => {
        sidebar(qs.type, qs.baselineId);
      }, 1500);
    }
  }, []);

  useEffect(() => {
    const {
      search,
    } = location;

    if (search !== prevSearchRef) {
      const qs = NavigationHelper.getParams();

      if (qs.baselineId || qs.type === 'new') {
        sidebar(qs.type, qs.baselineId);
      }
    }
  }, [location.search]);

  return (
    <div
      className={classNames('VisualBaselinesList', className)}
      style={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        ...style,
      }}
    >
      <SubNavigation
        title="Visual Baselines"
        buttons={[
          {
            text: 'New Visual Baseline',
            icon: viAdd,
            color: 'primary',
            url: NavigationHelper.updateParams({
              type: 'new',
            }),
            userCan: [
              'baseline.create',
            ],
          },
        ]}
      />

      <TableBaselines
        columns={[
          '.',
          'Name',
          'Company',
          'Description',
          'Locations',
          'Modified',
          'Tags',
          '...',
        ]}
        fetch={API.Baseline.list}
        filters={{
          mediaFormat: 'visual',
        }}
        defaultSortBy={{
          label: 'Name',
          attr: 'name',
          direction: 'asc',
        }}
        paginator
        paginatorProps={{
          label: 'Baselines',
          urlPaging: true,
          urlFilters: true,
        }}
        toggle
        toggleProps={{
          label: 'Show Archived Baselines',
          tooltip: true,
        }}
        bulk
        bulkProps={{
          edit: false,
          add: false,
          block: false,
          remove: false,
          archive: true,
        }}
        rowLink={{
          baselineId: '_id',
        }}
        menuItems={[
          { name: 'Archive', userCan: 'baseline.delete' },
        ]}
      />
    </div>
  );
}

VisualBaselinesList.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(null, mapDispatchToProps)(VisualBaselinesList));
